import { render, staticRenderFns } from "./ProjectProfileCard.vue?vue&type=template&id=73cb6781&scoped=true&"
import script from "./ProjectProfileCard.vue?vue&type=script&lang=js&"
export * from "./ProjectProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb6781",
  null
  
)

export default component.exports